import { FC } from 'react'
import classNames from 'classnames'
import s from '../index.module.css'
import CheckBoxSettings, {
  CustomCheckboxSettings,
} from '../components/CheckboxSettings'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { getChangeInput } from '../functions'
import { SETTINGS_TYPES } from '@/constant'

interface SettingsData {
  key: string
  value: string
  type: string
}

interface IStudentProfileSettings {
  changeSetting: (data: SettingsData) => void
  marker: boolean
}

const StudentProfileSettings: FC<IStudentProfileSettings> = ({
  changeSetting,
  marker,
}) => {
  const isShowParentNameChildStore = useSelector(
    (store: any) => store.settings.isShowParentNameChild,
  )
  const isShowParentPhoneChildStore = useSelector(
    (store: any) => store.settings.isShowParentPhoneChild,
  )
  const isShowParentEmailChildStore = useSelector(
    (store: any) => store.settings.isShowParentEmailChild,
  )
  const [parentInfo, setParentInfo] = useState(
    isShowParentNameChildStore == 1 &&
      isShowParentPhoneChildStore == 1 &&
      isShowParentEmailChildStore == 1,
  )
  useEffect(() => {
    setParentInfo(
      isShowParentNameChildStore == 1 &&
        isShowParentPhoneChildStore == 1 &&
        isShowParentEmailChildStore == 1,
    )
  }, [
    isShowParentEmailChildStore,
    isShowParentPhoneChildStore,
    isShowParentNameChildStore,
    marker,
  ])
  const changeInput = getChangeInput(changeSetting)
  const changeParentInfo = (value: boolean) => {
    setParentInfo(value)
    changeInput('isShowParentNameChild', value, SETTINGS_TYPES.GENERAL)
    changeInput('isShowParentPhoneChild', value, SETTINGS_TYPES.GENERAL)
    changeInput('isShowParentEmailChild', value, SETTINGS_TYPES.GENERAL)
  }

  return (
    <div className={classNames(s.dooble)}>
      <div className={s.left}>
        <div className={s.titleBlock}>Об учащемся</div>
        {settingsAboutChild.map((el, i) => (
          // @ts-ignore
          <CheckBoxSettings
            className={i == 0 ? s.largeMargin : s.checkboxMargin}
            changeSetting={changeSetting}
            marker={marker}
            label={el.label}
            name={el.name}
            key={i}
          />
        ))}
      </div>
      <div className={s.right}>
        <div className={classNames(s.titleBlock, s.ankBlock)}>
          О родителе
          {/* @ts-ignore */}
          <CustomCheckboxSettings
            value={parentInfo}
            onClick={() => changeParentInfo(!parentInfo)}
            //className={(i == 0) ? s.largeMargin : s.checkboxMargin}
          />
        </div>
        {settingsAboutParent.map((el, i) => (
          // @ts-ignore
          <CheckBoxSettings
            className={i == 0 ? s.largeMargin : s.checkboxMargin}
            changeSetting={changeSetting}
            marker={marker}
            label={el.label}
            name={el.name}
            key={i}
          />
        ))}
        <div className={classNames(s.titleBlock, s.anketsAdMargin)}>
          Дополнительно
        </div>
        {settingsAd.map((el, i) => (
          // @ts-ignore
          <CheckBoxSettings
            className={i == 0 ? s.largeMargin : s.checkboxMargin}
            changeSetting={changeSetting}
            marker={marker}
            label={el.label}
            name={el.name}
            key={i}
          />
        ))}
      </div>
    </div>
  )
}

export const settingsAboutChild = [
  {
    label: 'Номер телефона',
    name: 'isShowPhoneChild',
  },
  {
    label: 'Почта',
    name: 'isShowEmailChild',
  },
  {
    label: 'Пол',
    name: 'isShowGenderChild',
  },
  {
    label: 'Дата рождения',
    name: 'isShowDateOfBirthChild',
  },
  {
    label: 'Класс/образовательная траектория',
    name: 'isShowClassChild',
  },
  {
    label: 'Промокод',
    name: 'isShowPromoChild',
  },
  {
    label: 'Ссылка на соц. сеть',
    name: 'isShowLinkToSocialMediaNetChild',
  },
  {
    label: 'Город',
    name: 'isShowCityChild',
  },
  {
    label: 'ID',
    name: 'isShowIdChild',
  },
  {
    label: 'Указатель',
    name: 'isShowPointerChild',
  },
  {
    label: 'О себе',
    name: 'isShowAboutMeChild',
  },
  {
    label: 'Об ученике (Не видно учащемуся)',
    name: 'isShowAboutChild',
  },
  {
    label: 'Часовой пояс',
    name: 'isShowTimeZoneChild',
  },
]
const settingsAboutParent = [
  {
    label: 'ФИО',
    name: 'isShowParentNameChild',
  },
  {
    label: 'Почта',
    name: 'isShowParentEmailChild',
  },
  {
    label: 'Номер телефона',
    name: 'isShowParentPhoneChild',
  },
]
const settingsAd = [
  {
    label: 'Классы/образовательные траектории',
    name: 'isShowClassesChild',
  },
  {
    label: 'Курсы',
    name: 'isShowCoursesChild',
  },
  {
    label: 'Договора',
    name: 'isShowAgreementsChild',
  },
]

export default StudentProfileSettings
